import {uniq} from "lodash-es";
import {DateTimeType} from "../Constants/constants";

export const convertToSnakeCase = (value) => {
  return value
    .replace(/([A-Z])/g, "_$1")
    .trim()
    ?.toLowerCase();
};

export const convertToCameCase = (value) => {
  if (!value?.includes("_")) {
    return value;
  }
  let arr = value.split("_");

  return arr
    .map((value, index) => {
      return index === 0 ? value : value.charAt(0).toUpperCase() + value.slice(1);
    })
    ?.join("");
};

export const replaceDateUtil = (value, type) => {
  let date = `${value?.replace(/ /g, "T")}Z`;
  switch (type) {
    case DateTimeType.end:
      return date?.replace("00:00:00", "23:59:59")
    case DateTimeType.start:
    default:
      return date;
  }
};
export const exactSearchString = (values) => {
  return values?.map((value) => {
    return `"${value}"`;
  });
};

export const convertStrToObjColumns = (savedColumn) => {
  let displayColumn = typeof savedColumn === "string" ? JSON.parse(savedColumn) : savedColumn;
  displayColumn = {
    ...displayColumn,
    displayDefinition:
      typeof displayColumn?.displayDefinition === "string"
        ? JSON.parse(displayColumn?.displayDefinition)
        : displayColumn?.displayDefinition,
  };

  return displayColumn;
};

export const convertStrToObjFilters = (savedFilter) => {
  return typeof savedFilter === "string" ? JSON.parse(savedFilter) : savedFilter;
};

export const onlyUnique = (list) => {
  return uniq(list);
};
